import useApi, { Model, Query } from "../common/hooks/useApi";
import { AxiosError } from "axios";

export interface ConfiguracionProduccionId extends Model {
    Id: number
}

export interface ConfiguracionJuzgado extends Model {
    Id: number
    Nombre: string
    PeriodoCallCenter: number
    ConfiguracionesProduccion: ConfiguracionProduccionId[]
}

export interface ConfiguracionJuzgadoSave extends Omit<Partial<ConfiguracionJuzgado>, 'ConfiguracionesProduccion'> {
    
}

export interface ConfiguracionJuzgadoForm extends Omit<Partial<ConfiguracionJuzgado>, 'ConfiguracionesProduccion'> {
    ConfiguracionesProduccion: string[]
}

const module = "JuzgadoConfiguracion";
const moduleJuzgadoNotificacion = "JuzgadoNotificacion";
const moduleJuzgado = "Juzgado";

const useJuzgadoConfiguracionApi = () => {
    const api = useApi({ module });     
    return {
        list: (query: Query) => api.list!<ConfiguracionJuzgado>(query),
        save: (data: Partial<ConfiguracionJuzgadoSave>) => api.save!<Partial<ConfiguracionJuzgado>, ConfiguracionJuzgado>(data),
        delete: (id: number) => api.delete!<ConfiguracionJuzgado>(id),        
        pdfNotificacionJudicial: async (id: number, template: string | undefined) => {
            try {
                const response = await api.axiosInstance.request<Blob>({
                    url: `${moduleJuzgadoNotificacion}/DocumentoNotificacionJudicial/${id}/${template}`,
                    method: 'POST',
                    responseType: 'blob'
                })                
                const url = URL.createObjectURL(new Blob([response.data], { type:'application/pdf' })); 
                return { data: url };
            } catch (error: any | AxiosError) {
                return { error };
            }
        },
        pdfLibreDeuda: async (CuitCuilTitular: string, template: string | undefined) => {
            try {
                const response = await api.axiosInstance.request<Blob>({
                    url: `${moduleJuzgadoNotificacion}/DocumentoLibreDeuda/${CuitCuilTitular}/${template}`,
                    method: 'POST',
                    responseType: 'blob'
                })                
                const url = URL.createObjectURL(new Blob([response.data], { type:'application/pdf' })); 
                return { data: url };
            } catch (error: any | AxiosError) {
                return { error };
            }
        },
        consultarLibreDeuda: async (CuitCuilTitular: string) => {
            try {
                const response = await api.axiosInstance.get(`${moduleJuzgado}/Generar/LibreDeuda?CuitCuilTitular=${CuitCuilTitular}`);
                return response.data.result;
            } catch (error: any | AxiosError) {
                return { error };
            }
        },
    }
};

export default useJuzgadoConfiguracionApi;